<template>
    <div>
        <container-options-table></container-options-table>
    </div>
</template>
<script>
import ContainerOptionsTable from '@/components/container-options/ContainerOptionsTable.vue'
export default {
  components: { ContainerOptionsTable }
}
</script>
